interface PdfPreviewProps {
	url: string;
	filename: string;
}

/**
 * ブラウザ内蔵の PDF ビューアで表示する。contentUrl は同一オリジンなので Cookie 認証は
 * そのまま通り、Range リクエストによるストリーミングやキャッシュもブラウザに任せられる。
 * フラグメントで Chromium ビューアのツールバーとサイドバーを隠し、横幅フィットで開く
 * (Chromium 以外では無視され、素のビューアで表示される)。
 */
export function PdfPreview({ url, filename }: PdfPreviewProps) {
	return (
		<iframe
			src={`${url}#toolbar=0&navpanes=0&view=FitH`}
			title={filename}
			data-testid="pdf-preview"
			className="h-full w-full border-0"
		/>
	);
}
